module.exports = __webpack_public_path__ + "static/media/02.b036741f.jpg";